module.exports = __webpack_public_path__ + "img/scrm2img11.c4be2753.png";